import { render } from "./ImageElementOperate.vue?vue&type=template&id=db6d5ba6&scoped=true&ts=true"
import script from "./ImageElementOperate.vue?vue&type=script&lang=ts"
export * from "./ImageElementOperate.vue?vue&type=script&lang=ts"

import "./ImageElementOperate.vue?vue&type=style&index=0&id=db6d5ba6&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6d5ba6"]])

export default __exports__